/**
 * Shared behaviour for the PlantStrong product card (snippets/ps-product-card.liquid).
 *
 * Single source of truth for the card's variant <select> switching and Add-to-Cart,
 * so every section that renders the shared card (ps-collection-grid, ps-recipe-products,
 * and any future one) gets identical behaviour WITHOUT copying the logic inline.
 *
 * Uses event delegation on document (one change + one click listener), keyed on the
 * card's data-ps-* hooks. Only the shared snippet uses those hooks, so legacy cards
 * (class="product-card", data-add-to-cart) and Rebuy cards are never touched. Idempotent:
 * loading the file more than once will not double-bind.
 *
 * A card may set data-ps-card-source on its .ps-product-card root to tag the cart:update
 * event (defaults to 'ps-product-card'). Any value other than 'product-form-component'
 * makes <cart-icon> set the absolute count, which is what we want here.
 *
 * @author Maksym Mariukhnik
 */
window.PSProductCards = window.PSProductCards || (function () {
  'use strict';

  function onVariantChange(select) {
    var card = select.closest('.ps-product-card');
    if (!card) return;

    var selected = select.options[select.selectedIndex];
    var button = card.querySelector('[data-ps-add-to-cart]');
    var image = card.querySelector('.product-image img');
    var priceEl = card.querySelector('.product-price');
    var compareEl = card.querySelector('.product-compare-price');

    if (button) {
      button.dataset.variantId = selected.value;
      var available = selected.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? 'Add to Cart' : 'Sold Out';
    }

    if (image && selected.dataset.image) image.src = selected.dataset.image;
    if (priceEl && selected.dataset.price) priceEl.textContent = selected.dataset.price;

    if (selected.dataset.comparePrice) {
      if (compareEl) {
        compareEl.textContent = selected.dataset.comparePrice;
        compareEl.style.display = '';
      } else if (priceEl) {
        var newCompare = document.createElement('p');
        newCompare.className = 'product-compare-price';
        newCompare.textContent = selected.dataset.comparePrice;
        priceEl.insertAdjacentElement('afterend', newCompare);
      }
    } else if (compareEl) {
      compareEl.style.display = 'none';
    }
  }

  function addToCart(button) {
    var variantId = button.dataset.variantId;
    if (!variantId || button.disabled) return;

    var card = button.closest('.ps-product-card');
    var source = (card && card.dataset.psCardSource) || 'ps-product-card';
    var originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return fetch('/cart.js').then(function (cartResponse) {
          return cartResponse.json();
        });
      })
      .then(function (cart) {
        button.textContent = 'Added!';

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: button.id || null,
              data: {
                itemCount: cart.item_count,
                variantId: variantId,
                source: source,
              },
            },
          })
        );

        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.open();

        // Rebuy SmartCart: open the drawer. This Rebuy build exposes no
        // refresh() - calling it threw a TypeError that the chain's .catch()
        // turned into a bogus "Error" button state even though the add had
        // succeeded. Rebuy repopulates the drawer itself from its own patched
        // fetch on /cart/add.js.
        if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.show) {
          window.Rebuy.SmartCart.show();
        }

        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);
      })
      .catch(function () {
        button.textContent = 'Error';
        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 1800);
      });
  }

  // Delegated listeners — bind once, cover every .ps-product-card in the document,
  // including cards inside swipers or injected after load.
  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-ps-variant-select]');
    if (select) onVariantChange(select);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-ps-add-to-cart]');
    if (button) addToCart(button);
  });

  return { addToCart: addToCart, onVariantChange: onVariantChange };
})();
